import { Button } from 'antd';
import { availableReceiptActions, RECEIPT_ACTION_LABELS, type ReceiptAction } from '../policies/receipt-actions';
import type { ReceiptView } from '../receipts.api';

interface ReceiptActionsProps {
  receipt: Pick<ReceiptView, 'channel' | 'status'>;
  onAction: (action: ReceiptAction) => void;
  /** A table row navigates or selects on click; the buttons must not reach it. */
  size?: 'small';
}

/** The actions the receipt's channel and status allow. The caller renders this only for someone with `payment.record`. */
export function ReceiptActions({ receipt, onAction, size }: ReceiptActionsProps) {
  return (
    <span className="flex flex-wrap gap-x-1">
      {availableReceiptActions(receipt).map((action) => (
        <Button
          key={action}
          type={size === 'small' ? 'link' : 'default'}
          size={size}
          danger={action !== 'clear'}
          onClick={(event) => {
            event.stopPropagation();
            onAction(action);
          }}
        >
          {RECEIPT_ACTION_LABELS[action]}
        </Button>
      ))}
    </span>
  );
}
